// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-errors-bag{display:flex;flex-direction:column;margin-bottom:1.25rem}.v-errors-bag .v-alert{flex:1 0 auto}.v-errors-bag .v-alert:not(:last-child){margin-bottom:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
